export default __webpack_public_path__ + "static/media/images/christopher.9625b1d9.png";